import React from 'react';
import { REVIEWS, formatDate } from '../constants/site-data';

function Stars() {
  return (
    <span className="flex gap-0.5 text-gold" role="img" aria-label="5 trên 5 sao">
      {[0, 1, 2, 3, 4].map((i) => (
        <svg key={i} aria-hidden="true" width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </span>
  );
}

function CustomerReviews() {
  return (
    <section id="reviews" className="bg-cream">
      <div className="page-container flex flex-col gap-10 py-24">
        <div className="flex max-w-[40rem] flex-col gap-3">
          <span className="eyebrow text-accent">Đánh giá từ khách hàng</span>
          <h2 className="section-title">Khách mua lẻ lẫn đại lý đều quay lại.</h2>
        </div>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(min(300px,100%),1fr))] gap-5">
          {REVIEWS.map((review) => (
            <figure key={review.name} className="m-0 flex flex-col gap-5 rounded-3xl bg-white p-7">
              <Stars />
              <blockquote className="m-0 text-base leading-[1.65] text-ink-soft">“{review.text}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-3">
                <span aria-hidden="true" className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-forest text-[15px] font-bold text-gold">
                  {review.initials}
                </span>
                <span className="flex flex-col leading-[1.3]">
                  <strong className="text-[15px]">{review.name}</strong>
                  <time dateTime={review.date} className="text-[13px] text-muted">{formatDate(review.date)}</time>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CustomerReviews;
